/**
* Created by desheng.zhao on 2018/11/30.
*/
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import globalFn from './globalFn'

export const global = {
LoadingPlugin,
AlertPlugin,
ToastPlugin,
DatetimePlugin,
ConfirmPlugin,
globalFn
}




// WEBPACK FOOTER //
// ./src/plugins/index.js